import { Component } from "@angular/core";
import {
  AlertController,
  LoadingController,
  NavController,
  NavParams,
  ToastController,
} from "ionic-angular";
import { EcoEnelEmpresasProvider } from "../../../providers/ecoenel-empresas/ecoenel-empresas.provider";
import { ReciclagemCriarPage } from "../reciclagem-criar/reciclagem-criar";

/**
 * Pagina de detalhes de uma reciclagem
 * Mostra informacoes completas e historico
 * Permite reenviar se status for cancelada/expirada
 * Nota: Nao usa lazy loading - declarada no modulo pai
 */
@Component({
  selector: "page-reciclagem-detalhe",
  templateUrl: "reciclagem-detalhe.html",
})
export class ReciclagemDetalhePage {
  lancamentoId: number;
  lancamento: any = null;
  loading: boolean = true;
  perfil: string = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public provider: EcoEnelEmpresasProvider,
    public alertCtrl: AlertController,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    this.lancamentoId = this.navParams.get("id");
    this.getPerfil();
  }

  ionViewDidEnter() {
    this.carregarDetalhes();
  }

  getPerfil() {
    const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
    this.perfil = user.perfil && user.perfil.nome ? user.perfil.nome : "";
  }

  isGrandeGerador(): boolean {
    return this.perfil === "GRANDE GERADOR";
  }

  carregarDetalhes() {
    this.loading = true;

    this.provider.getLancamento(this.lancamentoId).subscribe(
      (data) => {
        this.lancamento = data;
        this.loading = false;
      },
      (err) => {
        this.showToast("Erro ao carregar detalhes");
        this.loading = false;
      }
    );
  }

  podeReenviar(): boolean {
    if (!this.lancamento || !this.isGrandeGerador()) return false;

    var status = this.lancamento.status && this.lancamento.status.codigo;
    return status === "X" || status === "E" || status === "P"; // Cancelada, Expirada ou Parcialmente Aprovada
  }

  temOrigem(): boolean {
    return this.lancamento && this.lancamento.lancamento_origem_id && this.lancamento.origem_lancamento;
  }

  getOrigemCodigo(): string {
    if (!this.temOrigem()) return "";
    return this.lancamento.origem_lancamento.codigo || ("ID " + this.lancamento.lancamento_origem_id);
  }

  reenviar() {
    this.navCtrl.push(ReciclagemCriarPage, {
      lancamentoOrigem: this.lancamento
    });
  }

  getStatusResiduoColor(status: string): string {
    if (status === "A") return "success";
    if (status === "R") return "danger";
    return "medium"; // P = Pendente
  }

  getStatusResiduoLabel(status: string): string {
    if (status === "A") return "Aprovado";
    if (status === "R") return "Recusado";
    return "Pendente";
  }

  getStatusColor(): string {
    if (!this.lancamento || !this.lancamento.status) return "primary";

    const colors = {
      S: "warning",
      R: "success",
      X: "danger",
      E: "medium",
    };
    return colors[this.lancamento.status.codigo] || "primary";
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("pt-BR");
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return (
      date.toLocaleDateString("pt-BR") +
      " " +
      date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
    );
  }

  formatCurrency(value: number): string {
    if (!value) return "R$ 0,00";
    return "R$ " + value.toFixed(2).replace(".", ",");
  }

  showAlert(msg: string) {
    this.alertCtrl
      .create({ title: "Aviso", message: msg, buttons: ["OK"] })
      .present();
  }

  showToast(msg: string) {
    this.toastCtrl.create({ message: msg, duration: 3000 }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ecoenel-empresas/reciclagem-detalhe/reciclagem-detalhe.ts